import { FaImage, FaUser, FaCalendar, FaFileAlt, FaDownload, FaExternalLinkAlt, FaCloudUploadAlt } from "react-icons/fa"
// import DeleteButton from "../ui/components/DeleteButton"
import DinamicBoxButton from "../ui/components/DinamicBoxButton"
import EditButton from "../ui/components/EditButton"
import { useState } from "react"
import axios from "axios"
import { BACKEND } from "../../config/configEnvs"
import { toast } from "react-toastify"
import Modal from "../ui/Modal"
import { FaSpinner, FaUpload, FaTrash } from "react-icons/fa"
import IdButton from "../ui/components/IdButton"
import CopyToClipBoard from "../../utils/CopyToClipBoard"
import LoadingScreen from "../ui/temp-screens/LoadingScreen"
import { FormatDateString } from "../../utils/FormatDate"
import DeleteButton from "../ui/components/DeleteButton"
import GenerateTxtFileAssignment from "../../utils/automateFuncions/GenerateTxtFileAssignment"
import { useSelector } from "react-redux"

const getValueFromPath = (object, path) => {
  if (!object || !path) return undefined
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), object)
}

const ItemRowInventarioStakeholders = ({ item, headersTableActive, headers, deleteItem, setter, openEditItem, workers }) => {

  const user = useSelector((state) => state.auth.user)
  
  const [openImagesModal, setOpenImagesModal] = useState(false)
  const [uploadingFile, setUploadingFile] = useState(false)

  // Funciones para manejo de archivos
  const uploadFile = async ({file, field}) => { 
    try {
      setUploadingFile(true)

      // Obtener los IDs existentes del campo (images o documents)
      const existingIds = item[field]?.map((item) => item.id) || []
      
      // Crear FormData para subir el archivo
      const formData = new FormData()
      formData.append('file', file)

      // Subir archivo a comprasImagenes
      const responseFile = await axios.post(`${BACKEND}/api/documentosInventario`, formData)
      const fileCreatedId = responseFile.data.doc.id

      // Actualizar el array de IDs en comprasStakeholders
      const response = await axios.put(`${BACKEND}/api/inventario/${item.id}`, {
        [field]: [...existingIds, fileCreatedId]
      })

      const docUpdated = response.data.doc

      // Actualizar el estado local con el nuevo registro
      setter(prev => prev.map(i => (
        i.id === item.id ? docUpdated : i
      )))
            
      // Recargar los datos de la compra para mostrar el nuevo archivo
      toast.success('Archivo subido exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo archivo')
    } finally {
      setUploadingFile(false)
    }
  }

  const deleteFile = async ({id, field}) => {
    try {
      // Obtener los IDs existentes del campo (images o documents)
      const existingIds = item[field]?.map((item) => item.id) || []
      
      // Filtrar el ID que se va a eliminar
      const updatedIds = existingIds.filter(fileId => fileId !== id)
      
      // 1. Eliminar el archivo de la colección comprasImagenes
      await axios.delete(`${BACKEND}/api/documentosInventario/${id}`)
      
      // 2. Actualizar el array de IDs en comprasStakeholders
      const responseItem = await axios.put(`${BACKEND}/api/inventario/${item.id}`, {
        [field]: updatedIds
      })
      
      const docUpdated = responseItem.data.doc
      
      // Actualizar el estado local con el registro actualizado
      setter(prev => prev.map(i => 
        i.id === item.id ? docUpdated : i
      ))
      
      toast.success('Archivo eliminado exitosamente')
      
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando archivo')
    }
  }

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank')
  }

  const getAssignments = async () => {
    try {
      setLoadingAssignments(true)
      const response = await axios.get(`${BACKEND}/api/asignacionesInventario?limit=0&where[item][equals]=${item.id}&depth=2&sort=-dateStart`)
      setAssignments(response.data.docs)
    } catch (error) {
      console.log(error)
      toast.error('Error obteniendo asignaciones')
    } finally {
      setLoadingAssignments(false)
    }
  }

  const [assignments, setAssignments] = useState([])
  const [loadingAssignments, setLoadingAssignments] = useState(false)
  const [modalAssignments, setModalAssignments] = useState(false)
  const [assignUpdating, setAssignUpdating] = useState(null)
  const [typeUpdating, setTypeUpdating] = useState(null)

  // Subir actas por asignación (entrega/devolución)
  const handleUploadActa = async ({ assignment, field, files }) => {
    try {
      if (!files || files.length === 0) return
      setUploadingFile(true)
      setAssignUpdating(assignment.id)
      setTypeUpdating(field)

      let createdDoc = null

      for (const file of Array.from(files)) {
        const formData = new FormData()
        formData.append('file', file)
        const responseFile = await axios.post(`${BACKEND}/api/documentosAsignaciones`, formData)
        const createdId = responseFile?.data?.doc?.id
        if (createdId) createdDoc = createdId
      }

      const response = await axios.put(`${BACKEND}/api/asignacionesInventario/${assignment.id}`, {
        [field]: createdDoc
      })

      const updated = response?.data?.doc
      if (updated) {
        setAssignments((prev) => prev.map((a) => (a.id === assignment.id ? updated : a)))
      }
      toast.success('Acta subida exitosamente')
    } catch (error) {
      console.log(error)
      toast.error('Error subiendo acta')
    } finally {
      setUploadingFile(false)
      setAssignUpdating(null)
      setTypeUpdating(null)
    }
  }

  // Eliminación de actas
  const deleteAssignmentActFile = async ({ assignment, field, id }) => {
    try {
  
      await axios.delete(`${BACKEND}/api/documentosAsignaciones/${id}`)
  
      const response = await axios.put(`${BACKEND}/api/asignacionesInventario/${assignment.id}`, {
        [field]: null
      })
  
      const updated = response?.data?.doc
      if (updated) {
        setAssignments((prev) => prev.map((a) => (a.id === assignment.id ? updated : a)))
      }
      toast.success('Archivo de acta eliminado')
    } catch (error) {
      console.log(error)
      toast.error('Error eliminando archivo de acta')
    }
  }

  return (
    <tr key={item.id} className="text-xs py-3 w-full text-gray-900 hover:bg-gray-100 transition-all duration-100">
      
      <Modal // Imágenes
        activeModal={openImagesModal}
        onClose={() => { setOpenImagesModal(false) }}
        title="Imágenes del ítem"
        className="max-w-4xl"
        centered
      >
        <div className="flex flex-col gap-4">
          {/* Sección de subida de imágenes */}
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
            <input
              type="file"
              id="image-upload"
              accept="image/*"
              multiple
              className="hidden"
              disabled={uploadingFile}
              onChange={(e) => {
                const files = Array.from(e.target.files)
                files.forEach(file => uploadFile({file, field: "media"}))
              }}
            />
            <label htmlFor="image-upload" className={`cursor-pointer ${uploadingFile ? 'opacity-50' : ''}`}>
              {uploadingFile ? (
                <FaSpinner className="mx-auto text-sm text-gray-400 mb-2 animate-spin" />
            ) : (
                <FaUpload className="mx-auto text-sm text-gray-400 mb-2" />
              )}
              <p className="text-gray-600 text-sm">
                {uploadingFile ? 'Subiendo...' : 'Haz clic para subir imágenes'}
              </p>
              <p className="text-xs mt-2 text-gray-400">PNG, JPG, JPEG hasta 5MB</p>
            </label>
          </div>

          {/* Lista de imágenes */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {item.media && item.media.length > 0 ? (
              item.media.map((image, index) => (
                <div key={index} className="border rounded-lg p-2 bg-white">
                  <div className="relative">
                    <img
                      src={image.url}
                      alt={`Imagen ${index + 1}`}
                      className="w-full h-32 object-cover rounded cursor-pointer"
                      onClick={() => openFileInNewTab(image.url)}
                    />
                    <button
                      onClick={() => deleteFile({id: image.id, field: "media"})}
                      className="absolute top-1 right-1 text-red-500 hover:text-red-700"
                      title="Eliminar imagen"
                    >
                      <FaTrash className="text-sm" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-xs text-center text-gray-500 py-8">
                No hay imágenes disponibles
              </div>
            )}
          </div>
        </div>
      </Modal>

      <Modal // Asignaciones
        activeModal={modalAssignments}
        onClose={() => { setModalAssignments(false) }}
        title={`Historial de Asignaciones - ${item.itemName || 'Ítem'}`}
        className="max-w-3xl"
        centered
      >
        {loadingAssignments ? (
          <LoadingScreen />
        ) : assignments.length === 0 ? (
          <div className="text-center py-8">
            <FaUser className="mx-auto text-3xl text-gray-300 mb-4" />
            <h3 className="text-xs font-semibold text-gray-600 mb-2">Sin asignaciones</h3>
            <p className="text-xs text-gray-500">Este ítem no tiene historial de asignaciones registrado.</p>
          </div>
        ) : (
          <div className="max-h-[70vh] overflow-y-auto">
            <div className="flex flex-col gap-4">
              {assignments.map((assignment, index) => (

                <div key={assignment.id} className="border shadow-sm bg-white border-gray-200 rounded-lg p-4">

                  {/* Header de la asignación */}
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                        <img src={assignment.user?.foto?.url} alt={assignment.user?.name} className="w-full h-full object-cover rounded-full" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 text-xs">
                          {assignment.user?.name || 'Usuario no disponible'}
                        </h3>
                        <p className="text-xs text-gray-500">
                          Asignación #{assignments.length - index}
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                        assignment.dateEnd 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-blue-100 text-blue-800'
                      }`}>
                        {assignment.dateEnd ? 'Finalizada' : 'Activa'}
                      </div>
                    </div>
                  </div>

                  {/* Fechas */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                    <div className="flex items-center gap-2">
                      <FaCalendar className="text-gray-400" />
                      <div>
                        <p className="text-xs text-gray-500">Fecha de inicio</p>
                        <p className="text-xs font-medium text-gray-900">
                          {assignment.dateStart ? FormatDateString(assignment.dateStart) : 'No especificada'}
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <FaCalendar className="text-gray-400" />
                      <div>
                        <p className="text-xs text-gray-500">Fecha de fin</p>
                        <p className="text-xs font-medium text-gray-900">
                          {assignment.dateEnd ? FormatDateString(assignment.dateEnd) : 'En curso'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Descripción */}
                  {assignment.description && (
                    <div className="mb-3">
                      <p className="text-xs text-gray-500 mb-1">Descripción</p>
                      <p className="text-xs text-gray-700 bg-gray-50 p-3 rounded border">
                        {assignment.description}
                      </p>
                    </div>
                  )}

                  {/* Documentos */}
                  {assignment.document && assignment.document.length > 0 && (
                    <div>
                      <p className="text-xs text-gray-500 mb-2">Documentos asociados</p>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                        {assignment.document.map((doc, docIndex) => (
                          <div key={docIndex} className="flex items-center gap-2 p-2 bg-gray-50 rounded border">
                            <FaFileAlt className="text-gray-400 text-sm" />
                            <span className="text-sm text-gray-700 flex-1 truncate">
                              {doc.filename || `Documento ${docIndex + 1}`}
                            </span>
                            <button
                              onClick={() => window.open(doc.url, '_blank')}
                              className="text-blue-600 hover:text-blue-800 p-1"
                              title="Ver documento"
                            >
                              <FaExternalLinkAlt className="text-xs" />
                            </button>
                            <button
                              onClick={() => {
                                const link = document.createElement('a')
                                link.href = doc.url
                                link.download = doc.filename || 'documento'
                                link.click()
                              }}
                              className="text-green-600 hover:text-green-800 p-1"
                              title="Descargar documento"
                            >
                              <FaDownload className="text-xs" />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Actas (Entrega / Devolución) */}
                  <div className="mt-3">  
                    <div className="flex items-center gap-2 mb-2 w-full">

                      {/* Input para Acta de Entrega */}
                      <div className="flex flex-row gap-2 items-center justify-center w-full">
                        <span className="text-xs text-gray-500">Acta de recepción</span>
                        {!assignment?.actaRecepcion ? (
                          <>
                            <DinamicBoxButton
                              content="Descargar acta de recepción."
                              icon={<FaDownload className="text-[10px]" />}
                              color={"blue"}
                              size="sm"
                              action={() => 
                                item?.media?.[0]?.url ?
                                GenerateTxtFileAssignment({
                                  day: new Date().getDate(),
                                  monthName: new Date().toLocaleString('default', { month: 'long' }),
                                  year: new Date().getFullYear(),
                                  assignedWorker: assignment.user.name,
                                  inventoryRegisterDate: item.createdAt,
                                  responsible: user.name,
                                  devolutionDate: new Date(),
                                  assignmentDate: assignment.dateStart,
                                  urlImage: item?.media?.[0]?.url || '',
                                  currency: item.buy.currency === "Soles" ? "S/." : "$",
                                  buyId: item.buy.id,
                                  buyCode: item.buy.receiptNumber,
                                  product: item.itemName,
                                  brand: item.buy.stakeholder.commercialName,
                                  price: item.buy.stakeholderProduct.price,
                                  buyDate: item.buy.paymentDate,
                                  type: "recepción",
                                }) : toast.warning('Para generar el acta de recepción, el ítem debe tener una imagen.')
                              }
                            />
                            <div>
                              <input
                                type="file"
                                id={`upload-acta-entrega-${assignment.id}`}
                                className="hidden"
                                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                disabled={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaRecepcion'}
                                onChange={(e) => handleUploadActa({ assignment, field: 'actaRecepcion', files: e.target.files })}
                              />
                              <DinamicBoxButton
                                content="Subir acta de recepción"
                                icon={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaRecepcion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                                disabled={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaRecepcion'}
                                color={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaRecepcion' ? 'gray' : 'green'}
                                size="sm"
                                action={() => document.getElementById(`upload-acta-entrega-${assignment.id}`)?.click()}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <DinamicBoxButton
                              content="Ver acta de recepción"
                              icon={<FaExternalLinkAlt className="text-[10px]" />}
                              color="blue"
                              size="sm"
                              action={() => {
                                const url = assignment?.actaRecepcion?.url || assignment?.actaRecepcion?.[0]?.url
                                if (url) window.open(url, '_blank')
                                else toast.info('No hay acta de recepción')
                              }}
                            />
                            <DinamicBoxButton
                              action={() => deleteAssignmentActFile({ assignment, field: 'actaRecepcion', id: assignment?.actaRecepcion?.id })}
                              content="Eliminar acta de recepción"
                              color="red"
                              icon={<FaTrash className="text-[10px]" />}
                            />
                          </>
                        )}

                      </div>

                      {/* Input para Acta de Devolución */}
                      <div className="flex flex-row gap-2 items-center justify-center w-full">
                        <span className="text-xs text-gray-500">Acta de devolucion</span>
                        {!assignment?.actaDevolucion ? (
                          <>
                            <DinamicBoxButton
                              content="Descargar acta de devolución."
                              icon={<FaDownload className="text-[10px]" />}
                              color={"blue"}
                              size="sm"
                              action={() => item?.media?.[0]?.url ? 
                                GenerateTxtFileAssignment({
                                  day: new Date().getDate(),
                                  monthName: new Date().toLocaleString('default', { month: 'long' }),
                                  year: new Date().getFullYear(),
                                  assignedWorker: assignment.user.name,
                                  responsible: user.name,
                                  devolutionDate: new Date(),
                                  assignmentDate: assignment.dateStart,
                                  urlImage: item?.media?.[0]?.url || '',
                                  currency: item.buy.currency === "Soles" ? "S/." : "$",
                                  buyId: item.buy.id,
                                  buyCode: item.buy.receiptNumber,
                                  product: item.itemName,
                                  brand: item.buy.stakeholder.commercialName,
                                  price: item.buy.stakeholderProduct.price,
                                  buyDate: item.buy.paymentDate,
                                  type: "devolución",
                                }) : toast.warning('Para generar el acta de devolución, el ítem debe tener una imagen.')
                              }
                            />
                            <div>
                              <input
                                type="file"
                                id={`upload-acta-devolucion-${assignment.id}`}
                                className="hidden"
                                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                disabled={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaDevolucion'}
                                onChange={(e) => handleUploadActa({ assignment, field: 'actaDevolucion', files: e.target.files })}
                              />
                              <DinamicBoxButton
                                content="Subir acta de devolución"
                                icon={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaDevolucion' ? <FaSpinner className="text-[10px] animate-spin" /> : <FaCloudUploadAlt className="text-[10px]" />}
                                disabled={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaDevolucion'}
                                color={uploadingFile && assignUpdating === assignment.id && typeUpdating === 'actaDevolucion' ? 'gray' : 'green'}
                                size="sm"
                                action={() => document.getElementById(`upload-acta-devolucion-${assignment.id}`)?.click()}
                              />
                            </div>
                          </>
                        ) : (
                          <>
                            <DinamicBoxButton
                              content="Ver acta de devolución"
                              icon={<FaExternalLinkAlt className="text-[10px]" />}
                              color="blue"
                              size="sm"
                              action={() => {
                                const url = assignment?.actaDevolucion?.url || assignment?.actaDevolucion?.[0]?.url
                                if (url) window.open(url, '_blank')
                                else toast.info('No hay acta de devolución')
                              }}
                            />
                            <DinamicBoxButton
                              action={() => deleteAssignmentActFile({ assignment, field: 'actaDevolucion', id: assignment?.actaDevolucion?.id })}
                              content="Eliminar acta de devolución"
                              color="red"
                              icon={<FaTrash className="text-[10px]" />}
                            />
                          </>
                        )}

                      </div>
                    </div>

                  </div>

                  {/* Duración de la asignación */}
                  {assignment.dateStart && (
                    <div className="mt-3 pt-3 border-t border-gray-100">
                      <p className="text-xs text-gray-500">
                        Duración: {
                          assignment.dateEnd 
                            ? `${Math.ceil((new Date(assignment.dateEnd) - new Date(assignment.dateStart)) / (1000 * 60 * 60 * 24))} días`
                            : `${Math.ceil((new Date() - new Date(assignment.dateStart)) / (1000 * 60 * 60 * 24))} días (en curso)`
                        }
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>

      {headers.map((header, idx) => (
        headersTableActive.find((e) => e.id === header.id)?.show && (
          header.value === "actions" ? (
            <td key={`actions-${idx}`} className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center">
                <EditButton
                  content="Editar item"
                  action={() => openEditItem(item)}
                />
                {/* <DeleteButton
                  content="Eliminar item"
                  action={() => deleteItem(item.id)}
                /> */}
                <DinamicBoxButton
                  content="Asignaciones"
                  icon={<FaUser/>}
                  color="purple"
                  action={() => {
                    getAssignments()
                    setModalAssignments(true)
                  }}
                />
              </div>
            </td>
          ) : header.value === "images" ? (
            <td key={idx} className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center items-center">
                <DinamicBoxButton
                  content="Ver imágenes"
                  icon={<FaImage/>}
                  action={() => setOpenImagesModal(true)}
                  backgroundColor="#3b82f6"
                  hoverBackgroundColor="#2563eb"
                  size="sm"
                />
                {item.media?.length > 0 && (
                  <span className="text-xs text-gray-500">
                    {item.media?.length}
                  </span>
                )}
              </div>
            </td>
          ) : header.value === "buy.id" ? (
            <td key={idx} className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
              <div className="flex flex-row gap-2 justify-center items-center">
                <IdButton
                  content={item.buy.id}
                  action={() => CopyToClipBoard(item.buy.id)}
                />
              </div>
            </td>
          ) : (
            (() => {
              const rawValue = getValueFromPath(item, header.value)
              const value = header.formatter ? header.formatter(rawValue, item.buy) : (rawValue ?? "-")
              return (
                <td key={idx} className={`px-4 py-1 border border-gray-300 truncate text-center z-10 ${value && value !== "-" ? "text-gray-900" : "text-gray-200"}`}>
                  {value}
                </td>
              )
            })()
          ))
        )
      )}
    </tr>
  )
} 
export default ItemRowInventarioStakeholders;